import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputSwitchChangeEvent } from 'primeng/inputswitch';

@Component({
  selector: 'app-input-switch',
  templateUrl: './input-switch.component.html',
})
export class InputSwitchComponent {
  @Input() checked: boolean = false;

  @Output() onChange = new EventEmitter();

  onSwitchClick(event: InputSwitchChangeEvent) {
    this.onChange.emit(event);
  }
}
